import { bandsOperation } from "../utils/bandOperation/bands";
import { isNumberArray } from "../utils/util";
export default function raster(data, cfg) {
  var extent = cfg.extent,
      width = cfg.width,
      height = cfg.height,
      min = cfg.min,
      max = cfg.max,
      format = cfg.format,
      operation = cfg.operation;
  var bandData;
  var rasterWidth;
  var rasterHeight;

  if (format === undefined || isNumberArray(data)) {
    // 兼容写法 - 用户直接传入解析完的波段数据
    bandData = Array.from(data);
    rasterWidth = width;
    rasterHeight = height;
  } else {
    // 用户传入为解析的栅格数据 - arraybuffer
    // 将数据统一为 IRasterFileData[]
    var imageDataList = Array.isArray(data) ? data : [data];
    bandData = bandsOperation(imageDataList, format, operation);
  }

  var resultData = {
    _id: 1,
    dataArray: [{
      _id: 1,
      data: bandData,
      width: rasterWidth,
      height: rasterHeight,
      min: min,
      max: max,
      coordinates: [[extent[0], extent[1]], [extent[2], extent[3]]]
    }]
  };
  return resultData;
}